import { Component } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';
import { DomSanitizer, SafeHtml } from "@angular/platform-browser";

@Component({
    selector: 'app-safe-text-renderer',
    templateUrl: './safe-text-renderer.component.html',
    standalone: false
})
export class SafeTextRendererComponent implements ICellRendererAngularComp {

    public text: string;
    params: ICellRendererParams;
    constructor(private sanitizer: DomSanitizer) {
    }

    onUserAction() {
        this.params.node.setData(this.params.data);
        this.params.eGridCell.click();
      }

    initilize(params: ICellRendererParams) {
        this.params = params;
        this.text = params.getValue();
    }

    // called on init
    agInit(params: any): void {
        this.initilize(params);
    }

    // called when the cell is refreshed
    refresh(params: any): boolean {
        this.initilize(params);
        return true;
    }

    sanitizerHtml(element) {
        let safeText = this.sanitizer.bypassSecurityTrustHtml(element);
        return safeText;
    }

}
